
/*
    🔥 ÚNICA FUENTE DE VERDAD DE LA EMPRESA

    Todo lo demás de esta carpeta lee de acá:
        _GetLogo.js        → nombre y rutas de los logos
        _MetaTags.js       → el subconjunto SEO
        _MetaTagsIcons.js  → favicons y escritura en el <head>
        _Company.js        → arma y congela el objeto final

    Cambiás de empresa tocando SÓLO este archivo.

    ⚠️ LAS IMÁGENES YA NO SE IMPORTAN: VIVEN EN public/_Imgs/

       Antes entraban como módulo desde la vieja carpeta _Imgs y las emitía webpack con
       hash. Ahora son rutas de texto que resuelve el navegador, y eso cambia tres cosas:

       1. Si borrás o renombrás un PNG, el build NO falla: te enterás con un 404 en
          pantalla. Por eso los logos tienen onerror con fallback al nombre en texto
          (lo maneja _GetLogo.js).
       2. No hay hash de cache-busting. Si reemplazás un PNG con el mismo nombre, el
          navegador del cliente puede seguir mostrando el viejo hasta que limpie caché.
       3. Las rutas se arman con PUBLIC_URL para que sigan andando si algún día
          deployás en un subdirectorio (miempresa.com/app/) en vez de la raíz.
*/


/*
    ⚠️ LOS VALORES CRUDOS VIVEN EN company.config.js

       Ese archivo está en CommonJS porque scripts/generate-company-env.js lo lee
       con require() desde Node, antes del build, y Node no puede requerir un
       archivo con export const.

       Acá se importa y se le suman las rutas de imagen, que necesitan
       process.env.PUBLIC_URL y sólo tienen sentido en el navegador.
*/
import COMPANY_CONFIG from "./company.config";


// ---------------------------------------- 🔥 ASSETS (VIVEN EN public/)
/*
    Estructura esperada dentro de public/:

        public/_Imgs/_Brand/LS_BRAND_light.png
        public/_Imgs/_Brand/LS_BRAND_dark.png
        public/_Imgs/_Brand/_Calendar/LS_BRAND_xmas_light.png
        public/_Imgs/_Brand/_Calendar/LS_BRAND_xmas_dark.png
        public/_Imgs/_Brand/_Calendar/LS_BRAND_flag_light.png
        public/_Imgs/_Brand/_Calendar/LS_BRAND_flag_dark.png
        public/_Imgs/_Favicon/FAVICON.png        <- fuente del favicon
        public/_Imgs/_Favicon/FAVICON_APPLE.png  <- fuente del icono Apple/PWA

    El prestart los copia a la raiz de public/ con un nombre versionado.

    ⚠️ ACÁ ESTÁN TODAS LAS RUTAS DE IMAGEN DEL PROYECTO Y EN NINGÚN LADO MÁS.
       Si movés la carpeta, tocás COMPANY_IMGS_PATH y se acomoda todo solo.
*/
const PUBLIC_URL = process.env.PUBLIC_URL ?? "";

const COMPANY_IMGS_PATH = `${PUBLIC_URL}/_Imgs`;
const COMPANY_BRAND_PATH = `${COMPANY_IMGS_PATH}/_Brand`;
const COMPANY_FAVICON_PATH = `${COMPANY_IMGS_PATH}/_Favicon`;
const COMPANY_CALENDAR_PATH = `${COMPANY_BRAND_PATH}/_Calendar`;

const COMPANY_IMGS = {

    /*
        PORTFOLIO DARK-ONLY:
        Ambos slots apuntan al MISMO archivo. De esta forma, para cambiar la
        marca en todo el sitio solo hay que reemplazar LS_BRAND_dark.png.
        LS_BRAND_light.png queda por compatibilidad historica, pero no se usa.
    */
    BRAND_LIGHT: `${COMPANY_BRAND_PATH}/LS_BRAND_dark.png`,
    BRAND_DARK: `${COMPANY_BRAND_PATH}/LS_BRAND_dark.png`,

    XMAS_LIGHT: `${COMPANY_CALENDAR_PATH}/LS_BRAND_xmas_light.png`,
    XMAS_DARK: `${COMPANY_CALENDAR_PATH}/LS_BRAND_xmas_dark.png`,
    FLAG_LIGHT: `${COMPANY_CALENDAR_PATH}/LS_BRAND_flag_light.png`,
    FLAG_DARK: `${COMPANY_CALENDAR_PATH}/LS_BRAND_flag_dark.png`,

    /*
        FAVICON VERSIONADO:
        index.html y React usan EXACTAMENTE la misma URL. El script prestart
        genera estos archivos desde public/_Imgs/_Favicon/.
    */
    FAVICON: `${PUBLIC_URL}/favicon-${COMPANY_CONFIG.COMPANY_ASSET_VERSION}.png`,
    FAVICON_APPLE: `${PUBLIC_URL}/apple-touch-icon-${COMPANY_CONFIG.COMPANY_ASSET_VERSION}.png`,
};


export const APP_COMPANY_CONFIG = {

    ...COMPANY_CONFIG,

    COMPANY_IMGS, COMPANY_IMGS_PATH, COMPANY_BRAND_PATH, COMPANY_CALENDAR_PATH, COMPANY_FAVICON_PATH,

};